/* eslint-disable import/no-named-as-default */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import gsap from '../../vendor/gsap/lib/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollToPlugin } from '../../vendor/gsap/lib/ScrollToPlugin';
import Card from './card';
import useDrag from './useDrag';
// import { requestScrollToView } from '../../state/actions/createThumbSlider';
import slicesThumb from '../../state/slices/thumbslider';

export default function Thumbs() {
  const locations = useSelector((state) => state.data.locations);
  const scrollIndex = useSelector((state) => state.thumbslider.scrollIndex);
  const dispatch = useDispatch();

  const { requestScrollToView } = slicesThumb.actions;

  const containerWidth = locations.length * 190;

  const scrollContainer = useRef();
  const leftArrow = useRef();
  const rightArrow = useRef();
  const { dragStart, dragStop, dragMove } = useDrag();

  const checkArrowsOpacity = () => {
    if (scrollContainer.current.scrollLeft <= 1) {
      rightArrow.current.style.opacity = 1;
      leftArrow.current.style.opacity = 0.1;
    } else if (
      scrollContainer.current.scrollLeft >=
      containerWidth - scrollContainer.current.offsetWidth - 1
    ) {
      rightArrow.current.style.opacity = 0.1;
      leftArrow.current.style.opacity = 1;
    } else {
      rightArrow.current.style.opacity = 1;
      leftArrow.current.style.opacity = 1;
    }
  };

  const handleDrag = (ev) =>
    dragMove(ev, (posDiff) => {
      if (scrollContainer.current) {
        // scrollContainer.current.scrollLeft += posDiff;
        gsap.to(scrollContainer.current, {
          // eslint-disable-next-line prefer-template
          scrollTo: { x: '+=' + posDiff },
          duration: 0.05,
          onComplete: checkArrowsOpacity,
        });
      }
    });

  const onNavClick = (dir) => {
    if (scrollContainer.current) {
      const symbol = dir === 'left' ? '-=' : '+=';
      console.log('scroll left pos', scrollContainer.current.scrollLeft);
      console.log('display size', scrollContainer.current.offsetWidth);
      console.log('containerWidth ', containerWidth);

      let targetValue;
      if (dir === 'left') {
        targetValue =
          scrollContainer.current.scrollLeft <
          scrollContainer.current.offsetWidth
            ? scrollContainer.current.scrollLeft
            : scrollContainer.current.offsetWidth;
      }

      if (dir === 'right') {
        const invisWidth = containerWidth - scrollContainer.current.offsetWidth;
        targetValue =
          scrollContainer.current.scrollLeft >
          invisWidth - scrollContainer.current.offsetWidth
            ? invisWidth - scrollContainer.current.scrollLeft
            : scrollContainer.current.offsetWidth;
      }

      const target = symbol + targetValue;
      gsap.to(scrollContainer.current, {
        // eslint-disable-next-line prefer-template
        scrollTo: { x: target },
        duration: 0.5,
        onComplete: checkArrowsOpacity,
      });
    }
  };

  // dynamically set a click on the map if index changes

  useEffect(() => {
    if (scrollContainer.current && scrollIndex !== -1) {
      // scrollContainer.current.scrollLeft += posDiff;
      gsap.to(scrollContainer.current, {
        // eslint-disable-next-line prefer-template
        scrollTo: { x: scrollIndex * 190 },
        duration: 0.5,
        onComplete: checkArrowsOpacity,
      });

      // reset after each scroll event
      dispatch(requestScrollToView(-1));
    }
  }, [scrollIndex]);

  return (
    <div className="thumbs-container" onMouseLeave={dragStop}>
      <div
        className="nav nav-left"
        ref={leftArrow}
        onClick={() => onNavClick('left')}
      >
        &#60;
      </div>
      <div
        className="thumbs-wrap"
        ref={scrollContainer}
        onMouseDown={(evt) => {
          dragStart(evt);
        }}
        onMouseUp={() => dragStop()}
        onMouseMove={handleDrag}
        onMouseLeave={dragStop}
      >
        {locations.map((obj) => {
          return <Card key={obj.id} {...obj} />;
        })}
      </div>
      <div
        className="nav nav-right"
        ref={rightArrow}
        onClick={() => onNavClick('right')}
      >
        &#62;
      </div>
    </div>
  );
}
